<template>
  <div class="map-selector">
    <div style="display: flex; align-items: center" v-show="changeFlag">
      <el-form-item label="地图选点" prop="">
        <el-input :id="inputId" v-model="mapName" autocomplete="off" placeholder="请输入地址" style="width: 200px" type="text"></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="longitude">
        <el-input v-model="longitude" placeholder="请输入经度" type="number" />
      </el-form-item>
      <el-form-item label="纬度" prop="latitude">
        <el-input v-model="latitude" placeholder="请输入纬度" type="number" />
      </el-form-item>
    </div>
    <div :id="mapId" :ref="mapId" :style="{ width: mapWidth, height: mapHeight }"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, defineProps, defineEmits, computed, defineExpose } from "vue";

const props = defineProps({
  lng: { type: [String, Number], default: 120.21551 },
  lat: { type: [String, Number], default: 30.253082 },
  longitude: { type: [String, Number], default: "" },
  latitude: { type: [String, Number], default: "" },
  mapName: { type: String, default: "" },
  changeFlag: { type: Boolean, default: true },
  mapWidth: { type: String, default: "100%" },
  mapHeight: { type: String, default: "300px" },
  mapId: { type: String, default: "allmap" },
});
const emit = defineEmits(["update:longitude", "update:latitude", "update:mapName", "update:cityName"]);

const longitude = ref(props.longitude);
const latitude = ref(props.latitude);
const mapName = ref(props.mapName);
const cityName = ref("");

watch(longitude, (val) => emit("update:longitude", val));
watch(latitude, (val) => emit("update:latitude", val));
watch(mapName, (val) => emit("update:mapName", val));
watch(cityName, (val) => emit("update:cityName", val));

let map = ref();

const inputId = computed(() => {
  return props.mapId + "Input";
});
function initMap(lng, lat) {
  // 百度地图API初始化
  map.value = new BMap.Map(props.mapId);
  console.log("要操作的对象：", map.value);
  map.value.clearOverlays();
  var point = new BMap.Point(lng, lat);

  if (longitude.value && latitude.value) {
    point = new BMap.Point(longitude.value, latitude.value);
    updateLocation();
    getAddressByPoint(point);
  }
  map.value.centerAndZoom(point, 15);
  map.value.addOverlay(new BMap.Marker(point));
  map.value.enableScrollWheelZoom();
  if (!props.changeFlag) return;
  var ac = new BMap.Autocomplete({
    input: inputId.value,
    location: map.value,
  });
  console.log("onconfirm", ac);

  var myValue;
  ac.addEventListener("onconfirm", function (e) {
    var _value = e.item.value;
    myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
    mapName.value = myValue;
    cityName.value = _value.city;

    setPlace();
  });

  function setPlace() {
    map.value.clearOverlays();
    function myFun() {
      longitude.value = local.getResults().getPoi(0).point.lng;
      latitude.value = local.getResults().getPoi(0).point.lat;
      var userlocation = local.getResults().getPoi(0).point;
      map.value.centerAndZoom(userlocation, 15);
      map.value.addOverlay(new BMap.Marker(userlocation));
    }
    var local = new BMap.LocalSearch(map.value, {
      onSearchComplete: myFun,
    });
    local.search(myValue);
  }

  map.value.addEventListener("click", function (e) {
    longitude.value = e.point.lng;
    latitude.value = e.point.lat;

    map.value.clearOverlays();
    var userlocation = e.point;
    map.value.centerAndZoom(userlocation, 15);
    map.value.addOverlay(new BMap.Marker(userlocation));
    const point = new BMap.Point(e.point.lng, e.point.lat);
    getAddressByPoint(point);
  });
}

function getAddressByPoint(point) {
  // 使用百度地图Geocoder进行逆地理编码
  const geocoder = new BMap.Geocoder();
  geocoder.getLocation(point, function (result) {
    if (result && result.address) {
      mapName.value = result.addressComponents.district + result.addressComponents.street + result.addressComponents.streetNumber;
      cityName.value = result.addressComponents.city;
    }
  });
}

// 根据输入的经纬度反查地址
function reverseGeocodeByInput() {
  if (!longitude.value || !latitude.value) {
    alert("请输入经纬度");
    return;
  }

  // 验证经纬度有效性
  if (isNaN(longitude.value) || isNaN(latitude.value)) {
    alert("经纬度格式不正确");
    return;
  }

  const point = new BMap.Point(longitude.value, latitude.value);
  // 更新地图标记位置
  map.value.clearOverlays();
  map.value.centerAndZoom(point, 15);
  map.value.addOverlay(new BMap.Marker(point));
  // 获取地址信息
  getAddressByPoint(point);
}
const updateLocation = () => {
  let point = new BMap.Point(props.longitude, props.latitude);
  map.value.clearOverlays();
  map.value.centerAndZoom(point, 15);
  map.value.addOverlay(new BMap.Marker(point));
  map.value.enableScrollWheelZoom();
};

onMounted(() => {
  initMap(props.lng, props.lat);
});
defineExpose({ updateLocation });
</script>

<style scoped>
.map-selector {
  width: 100%;
}
#allmap {
  border-width: 0;
}
</style>
